// PaymentSuccessModal.js
import React from 'react';
import { Modal, Button, Tag } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import './PaymentSuccessModal.css';

const PaymentSuccessModal = ({ visible, onClose, paymentDetails, formatDateTime }) => {
  return (
    <Modal
      title={
        <div style={{ textAlign: 'center', color: '#52c41a' }}>
          <CheckCircleOutlined style={{ fontSize: '24px', marginRight: '8px' }} />
          Payment Successful
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          Close
        </Button>
      ]}
      width={600}
    >
      <div className="success-modal-content">
        {/* Payment Summary Heading */}
        <h3 style={{ marginBottom: '15px', color: '#333' }}>Payment Summary</h3>

        <div className="transaction-details" style={{ backgroundColor: '#f0f9eb', padding: '15px', borderRadius: '8px' }}>
          <p><strong>Transaction ID:</strong> {paymentDetails?.transactionId}</p>
          <p><strong>Total Amount Paid:</strong> ₹{Number(paymentDetails?.totalPaidAmount).toFixed(2)}</p>
          <p><strong>Number of updated Invoices:</strong> {paymentDetails?.updatedInvoices?.length || 0}</p>
        </div>

        <div className="invoice-list-container">
          <h3>Updated Invoices</h3>
          <div className="scrollable-invoice-list">
            {paymentDetails?.updatedInvoices?.map((invoice, index) => (
              <div key={index} className="invoice-item">
                <div className="invoice-header">
                  <h5>Invoice #{invoice.invoiceId}</h5>
                  <Tag color={invoice.status === 1 ? 'green' : 'orange'}>
                    {invoice.status === 1 ? 'Fully Paid' : 'Partially Paid'}
                  </Tag>
                </div>
                <div className="invoice-details">
                  <div className="detail-row">
                    <span>Previous Balance:</span>
                    <span>₹{Number(invoice.previousBalance || 0).toFixed(2)}</span>
                  </div>
                  <div className="detail-row">
                    <span>Amount Paid:</span>
                    <span>₹{Number(invoice.amountPaid || 0).toFixed(2)}</span>
                  </div>
                  <div className="detail-row">
                    <span>New Balance:</span>
                    <span>₹{Number(invoice.newBalance || 0).toFixed(2)}</span>
                  </div>
                  {invoice.paymentDate && (
                    <div className="detail-row">
                      <span>Payment Date:</span>
                      <span>{formatDateTime(invoice.paymentDate)}</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentSuccessModal;